const getCustomFieldsData = (t) => {
  const customFieldColumns = [
    {
      Header: t("customFields.name"),
      accessor: "displayName",
      sortable: true,
    },
    {
      Header: t("customFields.type"),
      accessor: "type",
      sortable: true,
    },
    {
      Header: t("customFields.createdAt"),
      accessor: "created_at",
      sortable: true,
    },
    {
      Header: t("customFields.updatedAt"),
      accessor: "updated_at",
      sortable: true,
    },
  ];

  return { customFieldColumns };
};

export default getCustomFieldsData;
